import { Tag, TagLabel, TagLeftIcon } from "@chakra-ui/react";
import { t } from "i18next";
import { FaSignature } from "react-icons/fa";
import { SignedDocumentStatus } from "../../../../../autogen/bff-api";

interface Props {
  status: SignedDocumentStatus;
  size?: "sm" | "md" | "lg";
  width?: string;
}

export const SignedDocumentStatusTag = ({ status, size, width }: Props) => (
  <Tag
    colorScheme={signedDocumentStatusColor(status)}
    size={size}
    textAlign="center"
    justifyContent="center"
    width={width}
    py="0.5"
  >
    <TagLeftIcon as={FaSignature} />
    <TagLabel>{signedDocumentStatusText(status)}</TagLabel>
  </Tag>
);

export const signedDocumentStatusText = (status: SignedDocumentStatus): string => {
  switch (status) {
    case SignedDocumentStatus.Canceled:
      return t("Cancelled");
    case SignedDocumentStatus.Expired:
      return t("Expired");
    case SignedDocumentStatus.PartiallySigned:
    case SignedDocumentStatus.Unsigned:
      return t("Unsigned");
    case SignedDocumentStatus.Signed:
      return t("Signed");
    case SignedDocumentStatus.WaitingForAttachments:
      return t("Waiting for attachments");
  }
};

const signedDocumentStatusColor = (status: SignedDocumentStatus): string => {
  switch (status) {
    case SignedDocumentStatus.Canceled:
    case SignedDocumentStatus.Expired:
      return "red";
    case SignedDocumentStatus.PartiallySigned:
    case SignedDocumentStatus.Unsigned:
      return "orange";
    case SignedDocumentStatus.Signed:
      return "green";
    case SignedDocumentStatus.WaitingForAttachments:
      return "gray";
  }
};
